import { render, staticRenderFns } from "./lenders-for-bad-credits.vue?vue&type=template&id=a3360796&scoped=true"
import script from "./lenders-for-bad-credits.vue?vue&type=script&lang=js"
export * from "./lenders-for-bad-credits.vue?vue&type=script&lang=js"
import style0 from "./lenders-for-bad-credits.vue?vue&type=style&index=0&id=a3360796&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3360796",
  null
  
)

export default component.exports